import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ExternalIcon } from '../../../../../../common/icons';

import './FocusGauge.css';

@inject('translationsStore')
@observer
export default class FocusGauge extends Component {
  render() {
    const { title, valueWithIcon, dateDiff, onClick } = this.props;
    return (
      <div className="FocusGauge">
        <div className="FocusGaugesLabel">{title}:</div>
        <div className="FocusGaugesValue">{valueWithIcon}</div>
        <div className="FocusGaugesLastDate">
          <div>{dateDiff !== null ? dateDiff : '-'}</div>
          {onClick instanceof Function && (
            <div>
              <ExternalIcon style={{ width: '12px', height: '12px' }} onClick={onClick} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/FocusGauge/FocusGauge.js